<template>
  <div>
    <div class="btn-group-justify-end">
      <button @click="$router.push('grade/create')"
              class="button is-primary">등록</button>
    </div>

    <admin-simple-table :field_list="tableData"
                        :items="tableItems"
                        :filtered="filtered"
                        :allCount="allCount"
                        :filteredCount="filteredCount"
                        :table_width="1600"
                        @getData="getDataFromServer"
                        @ordering="ordering"
                        @selPageLength="selPageLength">
      <!-- 승인심사 종류 -->
      <div slot="approval_type" slot-scope="props">
        {{ approvalType(props.item) }}

      </div>

      <!-- 승인 방법 -->
      <div slot="is_auto_approval" slot-scope="props">
        {{ approvalMethod(props.item) }}
      </div>

      <div slot="modify_delete" slot-scope="props">
        <button class="button"
                @click.stop.prevent="clickItem(props.item,'update')">수정</button>
      </div>

    </admin-simple-table>
  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'UserGradeList',
    mixins: [
      ListMixin
    ],

    data() {
      return {
        modalSignout: '',   // 탈퇴시킬 번호
      }
    },
    created(){
      this.init();
    },
    methods: {
      init() {
        this.initializing('member_user_grade', 'member/grade');
      },
      getDataFromServer() {
        this.getData();
      },
      approvalType (item) {
        let text = '';
        switch(item.approval_type) {
          case 0:
            text = '컨텐츠 심사 후 승인';
            break;
          case 1:
            text = '활동지수 충족 시 승인';
            break;
          case 2:
            text = '둘다 충족 시 승인';
            break;
        }
        return text;
      },
      approvalMethod (item) {
        return item.is_auto_approval ? '컨텐츠 입력 및 활동지수 충족 시 자동으로 승인':'활동지수 충족 시 컨텐츠 심사 후 승인';
      },
      clickItem(item, types) {
        // 수정
        if (types === 'update') {
          this.$router.push('grade/create?id=' + item.id);
        }
        // 삭제
        else if (types === 'delete') {

          let value = {
            id: item.id,
            url: 'member/grade/',
            title: '회원등급을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      }
    }
  }
</script>

<style lang="styl" type="stylus" scoped>

</style>
